// Sparkline: a series as a small SVG line with an area fill and a dot on the last value, drawn in
// currentColor (set the colour with a text-* class). An image: give it a label that says the trend.
import { cn } from './cn';

export function Sparkline({
  values,
  label,
  width = 96,
  height = 24,
  className,
}: {
  values: number[];
  label: string;
  width?: number;
  height?: number;
  className?: string;
}) {
  const pad = 2;
  const lo = Math.min(...values);
  const hi = Math.max(...values);
  const span = hi - lo || 1;
  const step = values.length > 1 ? (width - pad * 2) / (values.length - 1) : 0;
  const pts = values.map((v, i) => [pad + i * step, height - pad - ((v - lo) / span) * (height - pad * 2)] as const);
  const line = pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const last = pts[pts.length - 1];
  const first = pts[0];
  return (
    <svg
      className={cn('inline-block overflow-visible align-middle', className)}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={label}
    >
      {first && last && (
        <>
          <polygon points={`${first[0]},${height} ${line} ${last[0]},${height}`} fill="currentColor" opacity="0.15" />
          <polyline points={line} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
          <circle cx={last[0]} cy={last[1]} r="2.5" fill="currentColor" />
        </>
      )}
    </svg>
  );
}
